/**
 * Novatus Energie Logo - inline SVG component matching the brand identity.
 * Green house with leaves + sun, in a rounded square card.
 */
import React from "react";

export const NovatusLogo = ({ size = 40, className = "" }) => {
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.22,
        background: "#FFFFFF",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 8px 24px -10px rgba(31,203,79,0.45)",
      }}
    >
      <svg viewBox="0 0 64 64" width={size * 0.74} height={size * 0.74} xmlns="http://www.w3.org/2000/svg">
        {/* House outline */}
        <path d="M14 30 L32 14 L50 30 L50 50 L14 50 Z" fill="none" stroke="#0F8A35" strokeWidth="2.5" strokeLinejoin="round" />
        {/* Sun behind */}
        <circle cx="40" cy="26" r="4.2" fill="#F59E0B" />
        {/* Leaves */}
        <path d="M22 36 C22 30, 26 26, 32 26 C32 32, 28 36, 22 36 Z" fill="#1FCB4F" />
        <path d="M42 38 C42 32, 38 28, 32 28 C32 34, 36 38, 42 38 Z" fill="#16A34A" />
        {/* Ground */}
        <rect x="14" y="48" width="36" height="2" fill="#0F8A35" />
        {/* Wordmark below (tiny) */}
        <text x="32" y="60" textAnchor="middle" fill="#0F8A35" fontSize="6.5" fontWeight="900" fontFamily="Inter,sans-serif" letterSpacing="0.5">
          NOVATUS
        </text>
      </svg>
    </div>
  );
};

export default NovatusLogo;
